import { render, staticRenderFns } from "./TimelineFullScreenGame.vue?vue&type=template&id=4b8a24b4&scoped=true&"
import script from "./TimelineFullScreenGame.vue?vue&type=script&lang=ts&"
export * from "./TimelineFullScreenGame.vue?vue&type=script&lang=ts&"
import style0 from "./TimelineFullScreenGame.vue?vue&type=style&index=0&id=4b8a24b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a24b4",
  null
  
)

export default component.exports